/**
 * Used by standalone transfer tables, to add samples from outside the current entry
 */
import React from 'react';

import {SampleDetails} from 'constants/SampleConstants';
import {ButtonStyle} from 'ui-library/buttons/Button';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import Modal from 'ui-library/modals/Modal';
import ExternalInputPicker, {
  ExternalInputSpecifierType,
} from 'workflows/stage-entries/components/ExternalInputPicker';

import convertInputSpecifierToSamples from './convertInputSpecifierToSamples';

interface AddExternalSamplesModalProps {
  onRequestClose: () => void;
  onSamplesSelected: (samples: Array<SampleDetails>) => void;
}

interface State {
  externalInputSpecifier: ExternalInputSpecifierType | null;
}

export class AddExternalSamplesModal extends React.Component<AddExternalSamplesModalProps, State> {
  override state: State = {
    externalInputSpecifier: null,
  };

  _handleSubmit = (): void => {
    if (this.state.externalInputSpecifier == null) {
      return;
    }
    const samples = convertInputSpecifierToSamples(this.state.externalInputSpecifier);
    if (samples.length > 0) {
      this.props.onSamplesSelected(samples);
    }
    this.props.onRequestClose();
  };

  _handleNewSpecifier = (externalInputSpecifier: ExternalInputSpecifierType): void => {
    this.setState({
      externalInputSpecifier,
    });
  };

  _isSelectedEntityNonContainable(): boolean {
    return (
      this.state.externalInputSpecifier != null &&
      this.state.externalInputSpecifier.bioentityInfo != null &&
      this.state.externalInputSpecifier.isContainable !== true
    );
  }

  override render(): JSX.Element {
    return (
      <Modal
        title="Add row"
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={this._handleSubmit}
        buttons={[
          {
            text: 'Add',
            submit: true,
            style: ButtonStyle.PRIMARY,
            disabled:
              this.state.externalInputSpecifier == null ||
              this._isSelectedEntityNonContainable() ||
              convertInputSpecifierToSamples(this.state.externalInputSpecifier).length === 0,
            key: 'add',
          },
        ]}
        dataTestAttrs={{component: 'ModalContainer', element: 'root'}}
      >
        <div>
          <FieldLabel label="Input" />
          <ExternalInputPicker
            allowContainers={true}
            externalInputSpecifier={this.state.externalInputSpecifier}
            onSetExternalInputSpecifier={this._handleNewSpecifier}
          />
          {this._isSelectedEntityNonContainable() && (
            <p className="u-mini-spacing-top">
              Cannot transfer entity "{this.state.externalInputSpecifier!.bioentityInfo!.name}" because it is
              not configured to be a sample.
            </p>
          )}
        </div>
      </Modal>
    );
  }
}
